(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["whipl-bundle-duo"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';

  const norm = value => String(value ?? '').trim().toLocaleLowerCase('de-DE');
  const codeKey = value => String(value ?? '').trim().toUpperCase();
  const numberPattern = /\d(?:[\d.,\u00a0\u202f ]*\d)?/;

  const moneyInput = value => {
    const text = String(value ?? '').trim();
    if (!/^\d+(?:[.,]\d{1,2})?$/.test(text)) return null;
    const result = Math.round(Number(text.replace(',', '.')) * 100);
    return Number.isSafeInteger(result) && result >= 0 ? result : null;
  };

  function colorIndex(product, fallback = 0) {
    if (!product || product.has_only_default_variant || !product.variants?.length) return -1;

    const names = (product.options || []).map(option => norm(option.name || option));
    const named = names.findIndex(name => /^(farbe|color|colour|couleur|colore|kleur)$/.test(name));

    if (named >= 0) return named;
    if (names.every(name => !name || name === 'title') && product.variants.length === 1) return -1;

    return Number(fallback) >= 0 && Number(fallback) < names.length
      ? Number(fallback)
      : -1;
  }

  const variantOptions = variant =>
    variant.options || [variant.option1, variant.option2, variant.option3];

  function modelFor(config, product) {
    if (config.model === 'base' || config.model === 'pro') return config.model;
    if (config.model !== 'auto' || !product?.id) return null;

    if (String(product.id) === String(config.proModel?.id || '')) return 'pro';

    if (
      config.duoEnabled === false &&
      String(product.id) === String(config.baseFirstId || '')
    ) return 'base';

    if (
      String(product.id) ===
      String(config.baseModel?.id || config.baseFirstId || '')
    ) return 'base';

    return null;
  }



    const colorLinkCache = new WeakMap();

  function colorLinks(profile) {
    if (!profile || typeof profile !== 'object') return null;

    const source = JSON.stringify(profile.colorLinks || []);
    const cached = colorLinkCache.get(profile);
    if (cached?.source === source) return cached.value;

    const value = {
      byVariant: new Map(),
      invalid: false,
      configured: false
    };

    const slots = new Set();

    for (const link of profile.colorLinks || []) {
      const rows = String(link.value || '').split(/\r?\n/);

      for (const row of rows) {
        if (!row.trim()) continue;

        value.configured = true;

        const match = row.trim().match(
          /^([1-7])\/([0-5])\s*=\s*(\d+(?:[\s,;]+\d+)*)$/
        );

        if (!match || !link.block) {
          value.invalid = true;
          continue;
        }

        const slot = Number(match[1]);
        const key = link.block + ':' + slot;
        const ids = new Set(match[3].split(/[\s,;]+/));

        if (
          slots.has(key) ||
          [...ids].some(id =>
            !Number.isSafeInteger(Number(id)) || Number(id) <= 0
          )
        ) {
          value.invalid = true;
          continue;
        }

        slots.add(key);

        const group = {
          block: link.block,
          slot,
          imageSlot: Number(match[2]),
          ids
        };

        for (const id of ids) {
          if (value.byVariant.has(id)) {
            value.invalid = true;
          }

          value.byVariant.set(id, group);
        }
      }
    }

    colorLinkCache.set(profile, { source, value });
    return value;
  }



    function mappedColor(profile, main, color, fallback = 0) {
    const links = colorLinks(profile);

    if (!links?.configured) return null;
    if (links.invalid) return { invalid: true };

    const index = colorIndex(main, fallback);
    const variants = main?.variants || [];

    const sources = index >= 0 && color
      ? variants.filter(variant =>
          norm(variantOptions(variant)[index]) === norm(color)
        )
      : variants;

    if (!sources.length) return { invalid: true };

    const groups = new Set(
      sources.map(variant =>
        links.byVariant.get(String(variant.id))
      ).filter(Boolean)
    );

    if (!groups.size) return null;
    if (groups.size !== 1) return { invalid: true };

    const group = [...groups][0];

    if (sources.some(variant =>
      !group.ids.has(String(variant.id))
    )) {
      return { invalid: true };
    }

    return group;
  }





    function resolveProduct(product, color, fallback = 0, fixedId = '', mapping = null) {
    if (mapping?.invalid) return null;

    const variants = product?.variants || [];

    const variantId = String(fixedId ?? '')
      .replace(/[\u200B-\u200D\uFEFF]/g, '')
      .trim();

    if (variantId) {
      return variants.find(variant =>
        String(variant.id) === variantId &&
        variant.available === true
      ) || null;
    }

    const index = colorIndex(product, fallback);

    if (mapping && index >= 0) {
      const matching = variants.filter(variant =>
        mapping.ids.has(String(variant.id))
      );

      return matching.length === 1 &&
        matching[0].available === true
        ? matching[0]
        : null;
    }

    let choices = variants.filter(variant =>
      variant.available === true
    );

    if (index >= 0 && color) {
      choices = choices.filter(variant =>
        norm(variantOptions(variant)[index]) === norm(color)
      );
    }

    return choices.length === 1 ? choices[0] : null;
  }

    function resolveOffer(offer, color, fallback = 0, mapping = null) {
    if (!offer?.products?.length) return null;

    const variants = offer.products.map((product, index) =>
      resolveProduct(
        product,
        color,
        fallback,
        index === 0 ? offer.fixedVariant : '',
        mapping
      )
    );

    if (variants.some(variant =>
      !variant ||
      !/^\d+$/.test(String(variant.id)) ||
      !Number.isSafeInteger(variant.price) ||
      variant.price < 0
    )) return null;

    const items = new Map();

    variants.forEach(variant => {
      const item = items.get(String(variant.id)) || {
        id: Number(variant.id),
        quantity: 0
      };

      item.quantity += 1;
      items.set(String(variant.id), item);
    });

    const price = variants.reduce(
      (sum, variant) => sum + variant.price,
      0
    );

    const compare = variants.reduce(
      (sum, variant) =>
        sum + Math.max(
          variant.price,
          Number(variant.compare_at_price) || 0
        ),
      0
    );

    return {
      variants,
      items: [...items.values()],
      price,
      compare
    };
  }

  function priceParts(
    base,
    allocation,
    currency,
    airReference = 0,
    straightReference = 0
  ) {
    let air = currency === 'EUR'
      ? moneyInput(allocation.airPrice)
      : null;

    const straight = currency === 'EUR'
      ? moneyInput(allocation.straightPrice)
      : null;

    const matches =
      air !== null &&
      straight !== null &&
      air + straight === base;

    if (!matches && !(air !== null && straight === null && air <= base)) {
      air = 0;
    }

    if (air === null || air > base) air = 0;

    const right = base - air;

    const enteredAirCompare = currency === 'EUR'
      ? moneyInput(allocation.airCompare)
      : null;

    const enteredStraightCompare = currency === 'EUR'
      ? moneyInput(allocation.straightCompare)
      : null;

    const airCompare = Math.max(
      air,
      enteredAirCompare ?? airReference
    );

    const straightCompare = Math.max(
      right,
      enteredStraightCompare ?? straightReference
    );

    return {
      air,
      straight: right,
      airCompare,
      straightCompare,
      compare: airCompare + straightCompare,
      allocationMatches: matches || straight === null
    };
  }

  function parseQuote(payload, context) {
    const result = payload?.data?.cartCreate;

    if (
      payload?.errors?.length ||
      result?.userErrors?.length ||
      !result?.cart
    ) {
      throw new Error('Quote unavailable');
    }

    const cart = result.cart;

    if (!(cart.discountCodes || []).some(discount =>
      discount.applicable === true &&
      codeKey(discount.code) === codeKey(context.code)
    )) return 0;

    const nodes = cart.lines?.nodes || [];

    if (nodes.length !== context.lines.length) {
      throw new Error('Unexpected quote lines');
    }

    let total = 0;
    let discount = 0;

    for (const expected of context.lines) {
      const matches = nodes.filter(node =>
        node.merchandise?.id === expected.merchandiseId
      );

      if (matches.length !== 1) {
        throw new Error('Unexpected merchandise');
      }

      const item = matches[0];
      const money = item.cost?.subtotalAmount;
      const cents = Math.round(Number(money?.amount) * 100);

      if (
        item.quantity !== expected.quantity ||
        money?.currencyCode !== context.currency ||
        !Number.isSafeInteger(cents) ||
        cents < 0
      ) {
        throw new Error('Quote context differs');
      }

      total += cents;

      for (const allocation of item.discountAllocations || []) {
        if (
          allocation.targetType !== 'LINE_ITEM' ||
          codeKey(allocation.code) !== codeKey(context.code)
        ) continue;

        const amount = allocation.discountedAmount;
        const value = Math.round(Number(amount?.amount) * 100);

        if (
          amount?.currencyCode !== context.currency ||
          !Number.isSafeInteger(value) ||
          value < 0
        ) {
          throw new Error('Unexpected discount currency');
        }

        discount += value;
      }
    }

    if (total !== context.base || discount > total) {
      throw new Error('Quote price differs');
    }

    return discount;
  }

  const helpers = {
    norm,
    moneyInput,
    colorIndex,
    modelFor,
    resolveProduct,
    resolveOffer,
    priceParts,
    parseQuote
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = helpers;
  }

  if (
    typeof customElements === 'undefined' ||
    customElements.get('whipl-duo-offers')
  ) return;

  const quoteCache = new Map();
  const live = new Set();
  let cartTask = null;

  const route = path =>
    (window.Shopify?.routes?.root || '/') + path;

  const imageUrl = image =>
    typeof image === 'string'
      ? image
      : image?.src || image?.url || '';

  async function jsonRequest(url, options = {}) {
    const abort = new AbortController();
    const timeout = setTimeout(() => abort.abort(), 15000);

    try {
      const response = await fetch(url, {
        cache: 'no-store',
        credentials: 'same-origin',
        ...options,
        signal: abort.signal,
        headers: {
          Accept: 'application/json',
          ...options.headers
        }
      });

      const data = await response.json();

      if (!response.ok || data?.status >= 400) {
        throw new Error(
          data?.description ||
          data?.message ||
          'Request failed'
        );
      }

      return data;
    } finally {
      clearTimeout(timeout);
    }
  }

  async function requestQuote(context) {
    const query =
      'mutation WhiplDuoPreview($input: CartInput!, $country: CountryCode, $count: Int!) @inContext(country: $country) {' +
      ' cartCreate(input: $input) { cart { discountCodes { code applicable } lines(first: $count) { nodes {' +
      ' quantity merchandise { ... on ProductVariant { id } } cost { subtotalAmount { amount currencyCode } }' +
      ' discountAllocations(lineLevelOnly: false) { targetType discountedAmount { amount currencyCode } ... on CartCodeDiscountAllocation { code } }' +
      ' } } } userErrors { message } } }';

    const input = {
      lines: context.lines,
      discountCodes: [context.code]
    };

    if (context.country) {
      input.buyerIdentity = {
        countryCode: context.country
      };
    }

    const payload = await jsonRequest('/api/2026-10/graphql.json', {
      method: 'POST',
      credentials: 'omit',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        query,
        variables: {
          input,
          country: context.country,
          count: context.lines.length
        }
      })
    });

    return parseQuote(payload, context);
  }

  function quote(context) {
    const key = JSON.stringify(context);
    let entry = quoteCache.get(key);

    if (!entry || entry.until < Date.now()) {
      entry = {
        until: Infinity
      };

      entry.promise = requestQuote(context)
        .then(amount => {
          entry.until = Date.now() + 45000;
          return amount;
        })
        .catch(() => {
          entry.until = Date.now() + 5000;
          return 0;
        });

      quoteCache.set(key, entry);

      if (quoteCache.size > 64) {
        quoteCache.delete(quoteCache.keys().next().value);
      }
    }

    return entry.promise;
  }

  function amountNode(element) {
    if (!element) return null;

    const walker = document.createTreeWalker(
      element,
      NodeFilter.SHOW_TEXT
    );

    let node;

    while ((node = walker.nextNode())) {
      if (
        !node.parentElement?.closest(
          's, del, .visually-hidden, .sr-only, script, style'
        ) &&
        numberPattern.test(node.nodeValue)
      ) return node;
    }

    return null;
  }

  class WhiplDuoOffers extends HTMLElement {
    connectedCallback() {
      this.panel = this.closest('.custom_model_product_content');

      this.visibilityChanged = () => {
        cancelAnimationFrame(this.visibilityFrame);

        this.visibilityFrame = requestAnimationFrame(() =>
          this.updateVisibility()
        );
      };

      this.visibilityObserver = new MutationObserver(
        this.visibilityChanged
      );

      this.visibilityObserver.observe(this, {
        attributes: true,
        attributeFilter: ['class', 'hidden', 'style']
      });

      if (this.panel) {
        this.visibilityObserver.observe(this.panel, {
          attributes: true,
          attributeFilter: ['class', 'hidden', 'style']
        });
      }

      window.addEventListener(
        'resize',
        this.visibilityChanged
      );

      if (typeof ResizeObserver !== 'undefined') {
        this.visibilityResize = new ResizeObserver(() => {
          const showing = this.visible();

          if (showing !== this.wasVisible) {
            this.visibilityChanged();
          }
        });

        this.visibilityResize.observe(this);
      }

      this.visibilityChanged();
    }

    visible() {
      return this.isConnected && !this.hidden && (
        !this.panel ||
        (
          this.panel.classList.contains('is-active') &&
          !this.panel.hidden
        )
      ) && (
        typeof this.getClientRects !== 'function' ||
        this.getClientRects().length > 0
      );
    }

    updateVisibility() {
      const showing = this.visible();
      this.wasVisible = showing;

      if (showing && !this.abort) {
        this.init();
      } else if (!showing && this.abort) {
        this.destroyUI();
      }
    }

    init() {
      try {
        this.config = JSON.parse(
          this.querySelector('[data-duo-config]').textContent
        );
      } catch (_) {
        return;
      }

      this.scope = this.closest('.product__info');

      if (!this.scope || !this.visible()) return;

      for (const item of [...live]) {
        if (
          item.scope === this.scope &&
          !item.active()
        ) {
          item.destroyUI();
        }
      }

      if ([...live].some(item =>
        item.scope === this.scope && item.active()
      )) return;

      this.abort = new AbortController();

      this.section = this.closest('[id^="shopify-section-"]');
      this.panel = this.closest('.custom_model_product_content');
      this.main = this.config.currentProduct;
      this.model = modelFor(this.config, this.main);
      this.profile = this.config.profiles?.[this.model];
      this.error = this.querySelector('[data-duo-error]');

      const invalidConfig =
        !this.profile ||
        !this.main?.id ||
        !this.main.variants?.length;

      if (invalidConfig) {
        this.profile = {
          title: '',
          leftTitle: '',
          allocation: {},
          offers: {}
        };

        for (const key of ['first', 'second', 'third', 'duo']) {
          this.profile.offers[key] = {
            products: [],
            title: '',
            features: '',
            mobileFeatures: '',
            images: []
          };
        }

        this.main = this.main || {
          variants: [],
          options: []
        };
      }

      this.offerData = this.profile.offers;
      this.cards = [...this.querySelectorAll('[data-offer]')];
      this.details = this.querySelector('[data-duo-details]');
      this.selected = '';
      this.sequence = 0;
      this.prices = new Map();
      this.savedElements = new Map();
      this.textPatches = new Map();
      this.colorControls = new Map();

      this.scope.classList.add('whipl-duo-managed');

      this.button =
        this.scope.querySelector(
          'button[data-product-add-to-cart-button]'
        ) ||
        this.scope.querySelector(
          '.native-button button[type="submit"]'
        );

      this.form =
        this.button?.form ||
        this.scope.querySelector('form[id^="product-form-"]');

      this.bindTicket();
      this.prepareButtons();

      const signal = this.abort.signal;

      this.addEventListener('click', event => {
        const card = event.target.closest('[data-offer]');

        if (card && this.contains(card)) {
          event.preventDefault();
          event.stopPropagation();
          this.select(card.dataset.offer);
        }

        const video = event.target.closest(
          '[data-duo-video-button]'
        );

        if (video) {
          event.preventDefault();
          this.openVideo();
        }

        if (event.target.closest('[data-duo-close]')) {
          this.closeVideo();
        }
      }, { signal });

      this.addEventListener('keydown', event => {
        if (
          [
            'ArrowLeft',
            'ArrowRight',
            'ArrowUp',
            'ArrowDown',
            'Home',
            'End'
          ].includes(event.key)
        ) {
          const current = event.target.closest('[data-offer]');
          if (!current) return;

          const enabled = this.cards.filter(card =>
            this.possibleColor(
              this.offerData[card.dataset.offer]
            ) !== null
          );

          if (!enabled.length) return;

          const index = enabled.indexOf(current);

          const next =
            event.key === 'Home'
              ? enabled[0]
              : event.key === 'End'
                ? enabled.at(-1)
                : enabled[
                    (
                      index +
                      (
                        event.key === 'ArrowLeft' ||
                        event.key === 'ArrowUp'
                          ? -1
                          : 1
                      ) +
                      enabled.length
                    ) % enabled.length
                  ];

          event.preventDefault();
          event.stopPropagation();
          next.focus();
          this.select(next.dataset.offer);
          return;
        }

        if (event.key !== 'Enter' && event.key !== ' ') return;

        const card = event.target.closest('[data-offer]');
        if (!card) return;

        event.preventDefault();
        event.stopPropagation();
        this.select(card.dataset.offer);
      }, { signal });

      const dialog = this.querySelector('[data-duo-dialog]');

      dialog?.addEventListener('close', () => {
        dialog.querySelectorAll('video').forEach(video =>
          video.pause()
        );

        dialog.querySelector(
          '[data-duo-dialog-media]'
        ).replaceChildren();
      }, { signal });

      this.querySelectorAll(
        'video[data-custom-poster]'
      ).forEach(video => {
        video.poster = video.dataset.customPoster;
      });

      const schedule = () => this.schedule();

      this.scope.addEventListener(
        'change',
        schedule,
        { signal }
      );

      this.scope.addEventListener('input', event => {
        if (event.target.name === 'quantity') {
          this.schedule();
        }
      }, { signal });

      [
        'variant:changed',
        'variant:change',
        'whipl:coupon-preview'
      ].forEach(name => {
        this.scope.addEventListener(
          name,
          schedule,
          { signal }
        );
      });

      document.addEventListener(
        'whipl:discount-updated',
        schedule,
        { signal }
      );

      document.addEventListener('shopify:block:select', event => {
        if (
          this.contains(event.target) ||
          event.detail?.blockId === this.dataset.blockId
        ) {
          this.schedule();
        }
      }, { signal });

      window.addEventListener('click', event => {
        const target = event.target.closest?.(
          'button, input[type="submit"], .custom-button-bundle'
        );

        if (!target || !this.active()) return;

        const ownButton =
          this.scope.contains(target) &&
          (
            target === this.button ||
            target.matches(
              '[data-product-add-to-cart-button], #AddToCart'
            ) ||
            target.closest('.custom-button-bundle')
          );

        const sticky =
          target.id === 'StickyAddToCart' &&
          this.section?.contains(target) &&
          this === this.activeInSection();

        if (!ownButton && !sticky) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        if (!target.disabled) {
          this.addToCart();
        }
      }, {
        capture: true,
        signal
      });

      window.addEventListener('submit', event => {
        if (
          event.target !== this.form ||
          !this.active()
        ) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        this.addToCart();
      }, {
        capture: true,
        signal
      });

      this.observer = new MutationObserver(schedule);

      if (this.panel) {
        this.observer.observe(this.panel, {
          attributes: true,
          attributeFilter: ['class', 'hidden']
        });
      }

      live.add(this);

      this.dataset.ready = invalidConfig ? 'false' : 'true';
      this.refresh(true);

      if (invalidConfig) {
        this.error.textContent = this.config.text.config;
        this.error.hidden = false;
      }
    }

    active() {
      return this.visible();
    }

    activeInSection() {
      return [...live].find(item =>
        item.section === this.section &&
        item.active()
      );
    }

    controls() {
      const index = colorIndex(
        this.main,
        this.config.colorPosition
      );

      if (index < 0) return [];

      return [
        ...this.scope.querySelectorAll(
          '[name="option' + (index + 1) + '"]'
        )
      ].filter(element =>
        element.matches('input[type="radio"], select')
      );
    }

    color() {
      const controls = this.controls();

      const chosen = controls.find(element =>
        element.matches('select') || element.checked
      );

      if (chosen) return chosen.value;

      const id = this.form?.querySelector('[name="id"]')?.value;

      const variant = this.main.variants?.find(variant =>
        String(variant.id) === String(id)
      );

      const index = colorIndex(
        this.main,
        this.config.colorPosition
      );

      return index >= 0
        ? variantOptions(
            variant ||
            this.main.variants?.find(variant =>
              variant.available
            ) ||
            {}
          )[index] || ''
        : '';
    }

    quantity() {
      const quantity = Number(
        this.scope.querySelector('[name="quantity"]')?.value || 1
      );

      return (
        Number.isSafeInteger(quantity) &&
        quantity > 0 &&
        quantity <= 999
      ) ? quantity : 1;
    }

    money(cents) {
      return new Intl.NumberFormat(
        document.documentElement.lang || 'de-DE',
        {
          style: 'currency',
          currency: this.config.currency
        }
      ).format(cents / 100);
    }

    number(cents) {
      return new Intl.NumberFormat(
        document.documentElement.lang || 'de-DE',
        {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }
      ).format(cents / 100);
    }

    saveElement(element) {
      if (
        !element ||
        this.savedElements.has(element)
      ) return;

      this.savedElements.set(element, {
        style: element.getAttribute('style'),
        color: element.style.getPropertyValue('color'),
        colorPriority: element.style.getPropertyPriority('color'),
        hidden: element.getAttribute('hidden'),
        disabled: element.getAttribute('disabled'),
        content: element.getAttribute('data-button-content'),
        busy: element.getAttribute('aria-busy')
      });
    }

    prepareButtons() {
      for (
        const element of this.scope.querySelectorAll(
          '.native-button, .custom-button-bundle, .shopify-payment-button'
        )
      ) {
        this.saveElement(element);

        element.style.setProperty(
          'display',
          element.matches('.native-button') ? 'block' : 'none',
          'important'
        );

        if (element.matches('.native-button')) {
          element.style.setProperty(
            'pointer-events',
            'auto',
            'important'
          );
        }
      }

      this.saveElement(this.button);
    }

    bindTicket() {
      const ticket = this.scope.querySelector(
        'whipl-discount-ticket'
      );

      if (
        !ticket ||
        ticket === this.ticket ||
        typeof ticket.renderPrice !== 'function'
      ) return;

      this.restoreTicket();

      if (
        ticket.__whiplDuoOwner &&
        ticket.__whiplDuoOwner !== this
      ) {
        ticket.__whiplDuoOwner.restoreTicket();
      }

      ticket.restorePriceText?.();

      this.ticket = ticket;
      ticket.__whiplDuoOwner = this;
      this.originalRenderPrice = ticket.renderPrice;

      const owner = this;

      this.wrappedRenderPrice = function (...args) {
        const result = owner.originalRenderPrice.apply(
          this,
          args
        );

        if (owner.isConnected) {
          owner.paintMain();
          owner.schedule();
        }

        return result;
      };

      ticket.renderPrice = this.wrappedRenderPrice;
    }

    restoreTicket() {
      if (
        this.ticket &&
        this.ticket.renderPrice === this.wrappedRenderPrice
      ) {
        this.ticket.renderPrice = this.originalRenderPrice;
      }

      if (this.ticket?.__whiplDuoOwner === this) {
        delete this.ticket.__whiplDuoOwner;
      }

      this.ticket = null;
    }

    schedule() {
      cancelAnimationFrame(this.refreshFrame);

      this.refreshFrame = requestAnimationFrame(() => {
        if (this.isConnected && this.abort) {
          this.refresh();
        }
      });
    }

        colorContext(color = this.color()) {
      return mappedColor(
        this.profile,
        this.main,
        color,
        this.config.colorPosition
      );
    }

    available(offer, color) {
      return resolveOffer(
        offer,
        color,
        this.config.colorPosition,
        this.colorContext(color)
      );
    }

    possibleColor(offer) {
      const values = this.controls().flatMap(control =>
        control.matches('select')
          ? [...control.options].map(option => option.value)
          : [control.value]
      );

      if (!values.length) {
        return this.available(offer, '') ? '' : null;
      }

      if (this.available(offer, this.color())) {
        return this.color();
      }

      return values.find(value =>
        this.available(offer, value)
      ) ?? null;
    }

    select(key) {
      if (this.busy) return;

      const offer = this.offerData[key];

      if (
        !offer ||
        !this.cards.some(card =>
          card.dataset.offer === key
        )
      ) return;

      const color = this.possibleColor(offer);
      if (color === null) return;

      this.selected = key;
      this.error.hidden = true;

      const controls = this.controls();

      const chosen = controls.find(element =>
        element.matches('select') ||
        norm(element.value) === norm(color)
      );

      if (chosen && this.color() !== color) {
        chosen.disabled = false;

        if (chosen.matches('select')) {
          chosen.value = color;
        } else {
          chosen.checked = true;
        }

        chosen.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      }

      this.refresh();
    }

    refresh(initial = false) {
      if (!this.active()) return;

      this.bindTicket();

      const currentColor = this.color();

      if (initial && !this.selected) {
        this.selected = this.cards
          .map(card => card.dataset.offer)
          .find(key =>
            this.possibleColor(this.offerData[key]) !== null
          ) || '';
      }

      const sequence = ++this.sequence;

      for (const card of this.cards) {
        const key = card.dataset.offer;
        const offer = this.offerData[key];
        const resolved = this.available(offer, currentColor);
        const possible = this.possibleColor(offer) !== null;
        const chosen = key === this.selected;

        card.classList.toggle('is-selected', chosen);

        card.classList.toggle(
  'bundle-card--active',
  chosen && card.classList.contains('bundle-card')
);

        card.classList.toggle(
          'is-unavailable',
          !possible
        );

        card.setAttribute(
          'aria-checked',
          String(chosen)
        );

        card.setAttribute(
          'aria-disabled',
          String(!possible || this.busy === true)
        );

        card.dataset.variantIds = resolved
          ? resolved.items.map(item => item.id).join(',')
          : '';

        const title = key === 'duo'
          ? this.profile.title
          : offer?.title;

        card.querySelector(
          '[data-offer-title]'
        ).textContent = title || '';

        const features = card.querySelector(
          '[data-offer-features]'
        );

        if (features) {
          const html = key === 'duo'
            ? this.profile.features || ''
            : offer?.features || '';

          if (features.innerHTML !== html) {
            features.innerHTML = html;
          }

          features.hidden = !html.trim();
        }

        const mobileFeatures = card.querySelector(
          '[data-offer-mobile-features]'
        );

        if (mobileFeatures) {
          const html = key === 'duo'
  ? this.profile.features || ''
  : offer?.mobileFeatures || offer?.features || '';

          if (mobileFeatures.innerHTML !== html) {
            mobileFeatures.innerHTML = html;
          }

          mobileFeatures.hidden = !html.trim();
        }

        const badge = card.querySelector(
          '[data-offer-badge]'
        );

        const badgeText = key === 'duo'
          ? this.config.duoBadge
          : offer?.badge || '';

        badge.hidden =
          !badgeText ||
          (key === 'duo' && !this.config.badgeShow);

        card.querySelector(
          '[data-offer-badge-text]'
        ).textContent = badgeText;

        card.querySelector(
          '[data-offer-badge-icon]'
        ).innerHTML = key === 'duo'
          ? ''
          : offer?.badgeIcon || '';

        const image = card.querySelector(
          '[data-offer-image]'
        );

        const variantImage = imageUrl(
          resolved?.variants[0]?.featured_image
        );

                const override = key === 'duo'
          ? this.duoColorImage('card', resolved, currentColor) || this.profile.cardImage
          : this.colorImage(offer, currentColor);

        const url =
          override ||
          variantImage ||
          imageUrl(offer?.products?.[0]?.featured_image);

        if (image && url) {
          if (image.tagName === 'IMG') {
            if (image.getAttribute('src') !== url) {
              image.src = url;
            }

            image.alt = title || '';
          } else {
            image.style.setProperty(
              'background-image',
              'url(' + JSON.stringify(url) + ')'
            );

            image.setAttribute(
              'aria-label',
              title || ''
            );
          }

          image.hidden = false;
        } else if (image) {
          image.hidden = true;
        }

        const unavailable = card.querySelector(
          '[data-offer-unavailable]'
        );

        unavailable.hidden = possible;

        const preview = this.prices.get(key);

        const next =
          preview &&
          preview.base === resolved?.price &&
          preview.color === currentColor &&
          preview.quantity === this.quantity() &&
          preview.code === this.currentCode()
            ? preview.discount
            : 0;

        this.paintCard(card, resolved, next);

        if (
          resolved &&
          this.active() &&
          this.previewAllowed(key)
        ) {
          const context = this.quoteContext(resolved);

          quote(context).then(discount => {
            if (
              !this.isConnected ||
              this.sequence !== sequence ||
              this.currentCode() !== context.code
            ) return;

            this.prices.set(key, {
              base: resolved.price,
              color: currentColor,
              quantity: this.quantity(),
              code: context.code,
              discount
            });

            this.paintCard(
              card,
              resolved,
              discount
            );

            if (key === this.selected) {
              this.paintMain();
            }

            if (key === 'duo') {
              this.paintDetails();
            }
          });
        }
      }

      this.filterColors();
      this.paintDetails();
      this.paintMain();
      this.paintMedia();
      this.updateButton();

      for (
        const input of this.scope.querySelectorAll(
          '[name="quantity"]'
        )
      ) {
        this.saveElement(input);
        input.disabled = this.busy === true;
      }

      this.querySelector(
        '[data-duo-selected-id]'
      ).value = this.available(
        this.offerData[this.selected],
        currentColor
      )?.items.map(item => item.id).join(',') || '';
    }

        colorImage(offer, color) {
      const mapping = this.colorContext(color);

      if (mapping?.invalid) return '';

      if (mapping) {
        return (offer?.images || []).find(item =>
          Number(item.slot) === mapping.imageSlot
        )?.image || '';
      }

      return (offer?.images || []).find(item =>
        norm(item.color) === norm(color)
      )?.image || '';
    }

    duoColorImage(field, resolved, color = this.color()) {
      if (!resolved) return '';

      const mapping = colorLinks(this.profile)?.byVariant.get(
        String(resolved.variants?.[0]?.id)
      ) || this.colorContext(color);

      if (mapping?.invalid) return '';

      if (mapping) {
        const entry = (this.profile.colorImages || []).find(item =>
          item.block === mapping.block &&
          Number(item.slot) === mapping.slot
        );

        return imageUrl(entry?.[field]);
      }

      const position = colorIndex(
        this.offerData.duo?.products?.[0],
        this.config.colorPosition
      );

      const variant = resolved.variants?.[0];

      const actualColor = position >= 0 && variant
        ? variantOptions(variant)[position] || color
        : color;

      const entry = (this.profile.colorImages || []).find(item =>
        norm(item.color) === norm(actualColor) &&
        imageUrl(item[field])
      );

      return imageUrl(entry?.[field]);
    }

    paintDuoAirImage(resolved) {
      const host = this.querySelector('[data-device="left"]');
      const frame = host?.querySelector('.wduo-media');

      if (!frame) return;

      const custom = this.duoColorImage('air', resolved);
      let image = host.querySelector('.wduo-media > img');

      if (!image && custom) {
        image = document.createElement('img');
        image.width = 600;
        image.height = 600;
        image.loading = 'lazy';
        image.dataset.duoDefaultSrc = '';
        frame.prepend(image);
      }

      if (!image) return;

      if (image.dataset.duoDefaultSrc === undefined) {
        image.dataset.duoDefaultSrc = image.getAttribute('src') || '';
      }

      const url = custom || image.dataset.duoDefaultSrc;
      const video = host.querySelector('video');

      if (url) {
        if (image.getAttribute('src') !== url) image.src = url;
      } else {
        image.removeAttribute('src');
      }

      image.alt = this.profile.leftTitle || '';
      image.hidden = !url || !!(video && !video.hidden);
    }

    currentCode() {
      return this.ticket?.selected
        ? String(this.ticket.code || '').trim()
        : '';
    }

    previewAllowed(key) {
      return (
        !!this.currentCode() &&
        this.ticket?.dataset.pricePreview === 'true' &&
        (
          key !== 'duo' ||
          (
            this.config.duoEnabled !== false &&
            this.config.couponPreview === true
          )
        )
      );
    }

    quoteContext(resolved) {
      const quantity = this.quantity();

      const raw =
        this.ticket?.dataset.country ||
        window.Shopify?.country ||
        this.config.country;

      return {
        code: this.currentCode(),
        currency: this.config.currency,
        country: /^[A-Z]{2}$/.test(raw) ? raw : null,
        base: resolved.price * quantity,
        lines: resolved.items.map(item => ({
          merchandiseId:
            'gid://shopify/ProductVariant/' + item.id,
          quantity: item.quantity * quantity
        }))
      };
    }

    discount(key, resolved) {
      if (!this.previewAllowed(key) || !resolved) return 0;

      const price = this.prices.get(key);

      if (
        !price ||
        price.base !== resolved.price ||
        price.quantity !== this.quantity() ||
        price.color !== this.color() ||
        price.code !== this.currentCode()
      ) return 0;

      return Math.min(
        resolved.price,
        Math.floor(price.discount / this.quantity())
      );
    }

    parts() {
      if (this.config.duoEnabled === false) return null;

      const resolved = this.available(
        this.offerData.duo,
        this.color()
      );

      if (!resolved) return null;

      const duoColorIndex = colorIndex(
        this.offerData.duo.products[0],
        this.config.colorPosition
      );

      const duoColor = duoColorIndex >= 0
        ? variantOptions(resolved.variants[0])[duoColorIndex]
        : this.color();

            const mapping = colorLinks(this.profile)?.byVariant.get(
        String(resolved.variants?.[0]?.id)
      ) || this.colorContext();

      const air =
        resolveProduct(
          this.profile.airReference,
          mapping ? this.color() : duoColor,
          this.config.colorPosition,
          '',
          mapping
        ) ||
        (!mapping && this.profile.airReference?.variants?.find(
          variant => variant.available
        ));

      const straight =
        this.config.straightReference?.variants?.find(
          variant => variant.available
        ) ||
        this.config.straightReference?.variants?.[0];

      const allocation = priceParts(
        resolved.price,
        this.profile.allocation,
        this.config.currency,
        Math.max(
          Number(air?.compare_at_price) || 0,
          Number(air?.price) || 0
        ),
        Math.max(
          Number(straight?.compare_at_price) || 0,
          Number(straight?.price) || 0
        )
      );

      const compare = allocation.compare > resolved.price
        ? allocation.compare
        : resolved.compare;

      return {
        ...allocation,
        resolved,
        compare,
        total:
          resolved.price -
          this.discount('duo', resolved)
      };
    }

    paintAmount(element, text) {
      if (!element) return;

      if (!element.querySelector('[data-offer-compare]')) {
        element.textContent = text;
        return;
      }

      let node = [...element.childNodes].find(child =>
        child.nodeType === 3 &&
        child.nodeValue.trim()
      );

      if (!node) {
        node = document.createTextNode('');
        element.insertBefore(node, element.firstChild);
      }

      node.nodeValue = text;
    }

    paintCard(card, resolved, directDiscount) {
      const key = card.dataset.offer;

      const current = card.querySelector(
        '[data-offer-price]'
      );

      const compare = card.querySelector(
        '[data-offer-compare]'
      );

      const amount = directDiscount === undefined
        ? this.discount(key, resolved)
        : Math.floor(
            directDiscount / this.quantity()
          );

      const shown = resolved
        ? Math.max(0, resolved.price - amount)
        : null;

      this.paintAmount(
        current,
        shown === null ? '—' : this.money(shown)
      );

      let reference = resolved?.compare || 0;

      if (key === 'duo') {
        reference = this.parts()?.compare || reference;
      }

      compare.textContent = this.money(reference);

      compare.hidden =
        shown === null ||
        reference <= shown ||
        (
          key === 'duo' &&
          !this.config.cardCompare
        );

      const badgeText = card.querySelector(
        '[data-offer-badge-text]'
      );

      const configuredBadge =
        this.offerData[key]?.badge || '';

      if (
        key !== 'duo' &&
        /€|EUR/.test(configuredBadge) &&
        shown !== null &&
        reference > shown
      ) {
                const currencyAmount = new RegExp(
          numberPattern.source + '\\s*(?:€|EUR)|' +
          '(?:€|EUR)\\s*' + numberPattern.source,
          'i'
        );

        badgeText.textContent = configuredBadge.replace(
          currencyAmount,
          () => this.money(reference - shown)
        );
      }

      card.classList.toggle(
        'has-extra-discount',
        amount > 0
      );

      card.style.setProperty(
        '--wduo-extra-color',
        this.ticket?.dataset.priceColor ||
        this.config.priceColor
      );
    }

    paintDetails() {
      const thirdCard = this.cards[2];

      const show =
        this.config.duoEnabled !== false &&
        this.config.detailsEnabled &&
        (
          this.config.detailsMode === 'always' ||
          (
            this.config.detailsMode === 'selected' &&
            this.selected === 'duo'
          ) ||
          (
            this.config.detailsMode === 'third' &&
            this.selected === thirdCard?.dataset.offer
          )
        );

      const common = this.querySelector(
        '[data-duo-common]'
      );

      if (common) {
        common.hidden =
          this.selected === 'duo' || show;
      }

      if (!this.details) return;

      this.details.hidden = !show;

      const leftTitle = this.querySelector(
        '[data-duo-left-title]'
      );

      if (leftTitle) {
        leftTitle.textContent = this.profile.leftTitle;
      }

            const parts = this.parts();
      this.paintDuoAirImage(parts?.resolved);

      const extra = parts
        ? parts.resolved.price - parts.total
        : 0;

      const netAir = parts
        ? Math.max(
            0,
            parts.air -
            Math.max(0, extra - parts.straight)
          )
        : null;

      const netStraight = parts
        ? Math.max(0, parts.straight - extra)
        : null;

      this.querySelector(
        '[data-duo-free]'
      )?.toggleAttribute(
        'hidden',
        !parts ||
        parts.air !== 0 ||
        !this.config.showFree
      );

      for (
        const [name, value] of Object.entries({
          'air-price': netAir,
          'straight-price': netStraight,
          'air-compare': parts?.airCompare,
          'straight-compare': parts?.straightCompare,
          'total': parts?.total,
          'total-compare': parts?.compare,
          'saving': parts
            ? Math.max(0, parts.compare - parts.total)
            : null
        })
      ) {
        for (
          const node of this.querySelectorAll(
            '[data-duo-' + name + ']'
          )
        ) {
          node.textContent = value == null
            ? '—'
            : this.money(value);
        }
      }

      for (
        const [selector, compare, price] of [
          ['air', parts?.airCompare, parts?.air],
          ['straight', parts?.straightCompare, parts?.straight],
          ['total', parts?.compare, parts?.total]
        ]
      ) {
        const node = this.querySelector(
          '[data-duo-' + selector + '-compare]'
        );

        if (node) {
          node.hidden =
            !this.config.showCompare ||
            !parts ||
            compare <= price;
        }
      }

      this.querySelectorAll(
        'video[data-duo-inline-video]'
      ).forEach(video => {
        if (!show || !this.active()) {
          video.pause();
        } else if (
          video.dataset.autoplay === 'true' &&
          !video.hidden &&
          video.paused
        ) {
          video.play().catch(() => {});
        }
      });

      if (!show) {
        this.closeVideo();
      }
    }

    patchNumber(element, cents) {
      const node = amountNode(element);
      if (!node) return;

      const old = this.textPatches.get(node);

      const updated = node.nodeValue.replace(
        numberPattern,
        this.number(cents)
      );

      this.textPatches.set(node, {
        original: old?.original ?? node.nodeValue,
        applied: updated
      });

      node.nodeValue = updated;
    }

    paintMain() {
      if (
        !this.config?.syncPrice ||
        !this.scope ||
        !this.offerData ||
        !this.active()
      ) return;

      const resolved = this.available(
        this.offerData[this.selected],
        this.color()
      );

      if (!resolved) return;

      const discount = this.discount(
        this.selected,
        resolved
      );

      const current = Math.max(
        0,
        resolved.price - discount
      );

      const compare = this.selected === 'duo'
        ? this.parts()?.compare || resolved.compare
        : resolved.compare;

      const list = this.scope.querySelector(
        '.product-meta .price-list'
      );

      const amount =
        list?.querySelector('.price--highlight') ||
        list?.querySelector(
          '.price:not(.price--compare)'
        );

      this.patchNumber(amount, current);

      const compareNode = list?.querySelector(
        '.price--compare'
      );

      if (compareNode) {
        this.saveElement(compareNode);
        this.patchNumber(compareNode, compare);
        compareNode.hidden = compare <= current;
      }

      if (amount) {
        this.saveElement(amount);

        if (discount > 0) {
          amount.style.setProperty(
            'color',
            this.ticket?.dataset.priceColor ||
            this.config.priceColor,
            'important'
          );
        } else {
          const saved = this.savedElements.get(amount);

          if (saved?.color) {
            amount.style.setProperty(
              'color',
              saved.color,
              saved.colorPriority
            );
          } else {
            amount.style.removeProperty('color');
          }
        }
      }

      const badge =
        this.scope.querySelector(
          '.product-meta__label-list .label--highlight'
        ) ||
        list?.querySelector('.label--highlight');

      if (badge) {
        this.saveElement(badge);

        const node = amountNode(badge);

        if (node && node.nodeValue.includes('%')) {
          const original =
            this.textPatches.get(node)?.original ??
            node.nodeValue;

          const percent = compare > 0
            ? Math.round(
                (compare - current) * 100 / compare
              )
            : 0;

          const applied = node.nodeValue.replace(
            numberPattern,
            String(Math.max(0, percent))
          );

          this.textPatches.set(node, {
            original,
            applied
          });

          node.nodeValue = applied;
        } else {
          this.patchNumber(
            badge,
            Math.max(0, compare - current)
          );
        }

        badge.hidden = compare <= current;
      }

      if (this.ticket) {
        const template = String(
          this.ticket.dataset.priceNoteText || ''
        ).trim();

        const showNote =
          discount > 0 &&
          this.ticket.dataset.showPriceNote === 'true' &&
          !!template;

        if (
          showNote &&
          !this.ticket.priceNote &&
          list
        ) {
          this.ticket.priceNote = document.createElement('p');

          this.ticket.priceNote.className =
            'whipl-price-preview-note';

          (
            list.closest(
              '.product-meta__price-list-container'
            ) || list
          ).insertAdjacentElement(
            'afterend',
            this.ticket.priceNote
          );
        }

        if (this.ticket.priceNote) {
          this.ticket.priceNote.hidden = !showNote;

          if (showNote) {
            const values = {
              code: this.currentCode(),
              sale: this.money(
                Math.max(
                  0,
                  compare - resolved.price
                )
              ),
              extra: this.money(discount)
            };

            this.ticket.priceNote.textContent =
              template.replace(
                /\{(code|sale|extra)\}/g,
                (_match, key) => values[key]
              );
          }
        }
      }
    }

    paintMedia() {
      if (
        !this.config.syncMedia ||
        !this.active()
      ) return;

      const product = this.closest('.product');

      const media = product?.querySelector(
        'product-media, .product__media'
      );

      if (!media) return;

      const offer = this.offerData[this.selected];

      const resolved = this.available(
        offer,
        this.color()
      );

      const useOriginal =
        this.selected === 'first' &&
        String(offer?.products?.[0]?.id) ===
        String(this.main.id);

      const url =
                (
          this.selected === 'duo' &&
          (
            this.duoColorImage('card', resolved) ||
            this.profile.cardImage
          )
        ) ||
        this.colorImage(offer, this.color()) ||
        imageUrl(
          resolved?.variants[0]?.featured_image
        ) ||
        imageUrl(
          offer?.products?.[0]?.featured_image
        );

      if (!this.mediaOverlay && url) {
        this.mediaRoot = media;

        this.mediaOverlay = document.createElement(
          'figure'
        );

        this.mediaOverlay.dataset.whiplOfferMedia = '';

        this.mediaOverlay.innerHTML =
          '<img loading="eager" alt="" width="900" height="900">';

        media.prepend(this.mediaOverlay);
      }

      media.classList.toggle(
        'whipl-duo-media-active',
        !useOriginal && !!resolved && !!url
      );

      if (this.mediaOverlay && url) {
        const image = this.mediaOverlay.querySelector('img');

        if (image.getAttribute('src') !== url) {
          image.src = url;
        }

        image.alt = this.selected === 'duo'
          ? this.profile.title
          : offer?.title || '';
      }
    }

    filterColors() {
      const offer = this.offerData[this.selected];
      if (!offer) return;

      const variantId = String(
        offer.fixedVariant ?? ''
      )
        .replace(/[\u200B-\u200D\uFEFF]/g, '')
        .trim();

      const noColors =
        !!variantId ||
        offer.products.every(product =>
          colorIndex(
            product,
            this.config.colorPosition
          ) < 0
        );

      for (const control of this.controls()) {
        const box = control.closest(
          '.product-form__option-selector'
        );

        if (box) {
          this.saveElement(box);

          const keepSingleColor =
            (
              this.model === 'pro' ||
              this.config.duoEnabled === false
            ) &&
            this.main?.variants?.length === 1 &&
            !variantId;

          box.hidden =
            noColors && !keepSingleColor;
        }

        if (control.matches('select')) {
          if (!this.colorControls.has(control)) {
            this.colorControls.set(
              control,
              control.disabled
            );
          }

          control.disabled = this.busy === true;

          for (const option of control.options) {
            if (!this.colorControls.has(option)) {
              this.colorControls.set(
                option,
                option.disabled
              );
            }

            option.disabled =
              this.busy === true ||
              !this.available(
                offer,
                option.value
              );
          }
        } else {
          if (!this.colorControls.has(control)) {
            this.colorControls.set(
              control,
              control.disabled
            );
          }

          control.disabled =
            this.busy === true ||
            !this.available(
              offer,
              control.value
            );

          const label = control.closest(
            '.color-swatch'
          );

          if (label) {
            label.classList.toggle(
              'whipl-duo-color-unavailable',
              control.disabled
            );
          }
        }
      }
    }

    updateButton() {
      if (!this.button) return;

      const available = !!this.available(
        this.offerData[this.selected],
        this.color()
      );

      this.button.disabled =
        this.busy === true || !available;

      this.button.setAttribute(
        'aria-busy',
        String(this.busy === true)
      );

      const text = available
        ? this.selected === 'duo'
          ? this.config.text.atc
          : this.config.text.normalAtc
        : this.config.text.choose;

      const container = this.button.querySelector(
        '.loader-button__text'
      );

      if (container) {
        if (!this.buttonText) {
          this.buttonText = {
            node: container,
            original: container.textContent
          };
        }

        container.textContent = text;
      } else {
        const node = [...this.button.childNodes].find(
          child =>
            child.nodeType === 3 &&
            child.nodeValue.trim()
        );

        if (node) {
          if (!this.buttonText) {
            this.buttonText = {
              node,
              original: node.nodeValue
            };
          }

          node.nodeValue = text;
        }
      }

      this.button.setAttribute(
        'data-button-content',
        text
      );
    }

    async addToCart() {
      if (
        this.busy ||
        cartTask ||
        !this.active()
      ) return;

      const offer = this.offerData[this.selected];

      const resolved = this.available(
        offer,
        this.color()
      );

      if (!resolved) {
        this.error.textContent =
          this.config.text.choose;

        this.error.hidden = false;
        return;
      }

      if (
        this.form &&
        !this.form.reportValidity()
      ) return;

      this.busy = true;
      this.dataset.busy = 'true';

      this.filterColors();
      this.updateButton();

      for (
        const input of this.scope.querySelectorAll(
          '[name="quantity"]'
        )
      ) {
        this.saveElement(input);
        input.disabled = true;
      }

      const operation = this.performAdd(
        offer,
        resolved
      );

      cartTask = operation;

      try {
        await operation;
      } catch (error) {
        if (this.isConnected) {
          this.error.textContent =
            error.publicMessage ||
            this.config.text.error;

          this.error.hidden = false;
        }
      } finally {
        if (cartTask === operation) {
          cartTask = null;
        }

        this.busy = false;
        this.dataset.busy = 'false';

        if (this.isConnected) {
          this.refresh();
        }
      }
    }

    async performAdd(offer, resolved) {
      const fresh = await Promise.all(
        offer.products.map(product =>
          jsonRequest(
            route(
              'products/' +
              encodeURIComponent(product.handle) +
              '.js'
            )
          )
        )
      );

      const currentOffer = {
        ...offer,
        products: fresh
      };

            const checked = this.available(
        currentOffer,
        this.color()
      );

      if (
        !checked ||
        JSON.stringify(checked.items) !==
        JSON.stringify(resolved.items)
      ) {
        throw new Error('Offer changed');
      }

      offer.products = fresh;

      if (checked.price !== resolved.price) {
        const changed = new Error('Price changed');

        changed.publicMessage =
          this.config.text.priceChanged;

        throw changed;
      }

      const quantity = this.quantity();
      let properties = {};

      if (this.form) {
        for (
          const [key, value] of new FormData(this.form)
        ) {
          const match = key.match(
            /^properties\[(.+)\]$/
          );

          if (
            match &&
            typeof value === 'string'
          ) {
            properties[match[1]] = value;
          }
        }
      }

      const items = checked.items.map((item, index) => ({
        id: item.id,
        quantity: item.quantity * quantity,
        ...(
          index === 0 &&
          Object.keys(properties).length
            ? { properties }
            : {}
        )
      }));

      this.error.hidden = true;

      await jsonRequest(route('cart/add.js'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items })
      });

      if (
        this.ticket?.selected &&
        typeof this.ticket.syncDiscountAfterAdd === 'function'
      ) {
        try {
          await this.ticket.syncDiscountAfterAdd();
        } catch (_) {
          // Das Angebot wurde bereits erfolgreich hinzugefügt.
        }
      }

      let cart;

      try {
        cart = await jsonRequest(route('cart.js'));
      } catch (_) {
        this.error.textContent =
          this.config.text.added;

        this.error.hidden = false;

        const link = this.querySelector(
          '[data-duo-cart-link]'
        );

        link.href = route('cart');
        link.hidden = false;

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: {
              openMiniCart: true
            }
          })
        );

        return;
      }

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart }
        })
      );

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: {
            cart,
            openMiniCart: true
          }
        })
      );

      if (
        !document.querySelector('cart-drawer#mini-cart')
      ) {
        const link = this.querySelector(
          '[data-duo-cart-link]'
        );

        link.href = route('cart');
        link.hidden = false;
      }
    }

    openVideo() {
      const side = this.config.videoTarget;

      const host = this.querySelector(
        '[data-device="' + side + '"]'
      );

      const video = host?.querySelector('video');

      if (!video) return;

      if (this.config.videoAction === 'dialog') {
        const dialog = this.querySelector(
          '[data-duo-dialog]'
        );

        if (
          typeof dialog?.showModal === 'function'
        ) {
          const clone = video.cloneNode(true);

                    clone.controls = true;
          clone.autoplay = false;
          clone.hidden = false;
          clone.preload = 'auto';
          clone.playsInline = true;
          clone.muted = video.muted;
          clone.defaultMuted = video.muted;
          clone.loop = video.loop;

          clone.setAttribute('playsinline', '');
          clone.setAttribute('webkit-playsinline', '');
          clone.removeAttribute('autoplay');

          clone.removeAttribute(
            'data-duo-inline-video'
          );

          dialog.querySelector(
            '[data-duo-dialog-media]'
          ).replaceChildren(clone);

                    dialog.showModal();
          clone.load();

          const playRequest = clone.play();

          if (playRequest && typeof playRequest.catch === 'function') {
            playRequest.catch(() => {
              clone.pause();
            });
          }

          return;
        }
      }

      host.querySelector(
        '.wduo-media'
      )?.classList.add('is-playing');

      video.controls = true;
      video.hidden = false;

      const image = host.querySelector(
        '.wduo-media > img'
      );

      if (image) {
        image.hidden = true;
      }

      host.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });

      video.play().catch(() => {});
    }

    closeVideo() {
      const dialog = this.querySelector(
        '[data-duo-dialog]'
      );

      if (!dialog?.open) return;

      dialog.querySelectorAll('video').forEach(
        video => video.pause()
      );

      dialog.close();

      dialog.querySelector(
        '[data-duo-dialog-media]'
      ).replaceChildren();
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.visibilityFrame);

      this.visibilityObserver?.disconnect();
      this.visibilityResize?.disconnect();

      if (this.visibilityChanged) {
        window.removeEventListener(
          'resize',
          this.visibilityChanged
        );
      }

      this.destroyUI();
    }

    destroyUI() {
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.refreshFrame);

      this.abort?.abort();
      this.abort = null;

      this.observer?.disconnect();
      ++this.sequence;

      this.querySelectorAll('video').forEach(
        video => video.pause()
      );

      this.closeVideo();
      this.restoreTicket();

      live.delete(this);

      if (
        this.scope &&
        ![...live].some(
          item => item.scope === this.scope
        )
      ) {
        this.scope.classList.remove(
          'whipl-duo-managed'
        );
      }

      this.mediaRoot?.classList.remove(
        'whipl-duo-media-active'
      );

      this.mediaOverlay?.remove();
      this.mediaOverlay = null;
      this.mediaRoot = null;

      for (
        const [node, patch] of this.textPatches || []
      ) {
        if (node.nodeValue === patch.applied) {
          node.nodeValue = patch.original;
        }
      }

      for (
        const [element, saved] of this.savedElements || []
      ) {
        for (
          const [name, value] of [
            ['style', saved.style],
            ['hidden', saved.hidden],
            ['disabled', saved.disabled],
            ['data-button-content', saved.content],
            ['aria-busy', saved.busy]
          ]
        ) {
          if (value === null) {
            element.removeAttribute(name);
          } else {
            element.setAttribute(name, value);
          }
        }
      }

      for (
        const [control, disabled] of this.colorControls || []
      ) {
        control.disabled = disabled;

        control.closest(
          '.color-swatch'
        )?.classList.remove(
          'whipl-duo-color-unavailable'
        );
      }

      if (this.buttonText) {
        if (this.buttonText.node.nodeType === 3) {
          this.buttonText.node.nodeValue =
            this.buttonText.original;
        } else {
          this.buttonText.node.textContent =
            this.buttonText.original;
        }
      }

      this.buttonText = null;
      this.dataset.ready = 'false';
    }
  }

  customElements.define(
    'whipl-duo-offers',
    WhiplDuoOffers
  );
})();
  } catch(e) { console.error(e); }
})();

})();
